module.exports = __webpack_public_path__ + "static/media/leclerc-logo.5a4a54de.png";